import { SvgIcon, SvgIconProps } from '@mui/material';

const AccountIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 33 33">
    <g fill="currentColor" fillRule="evenodd">
      <path d="M16.5 32c5.682 0 11-2.864 11-7.25 0-2.922-5.57-7.25-11-7.25-5.75 0-11 3.852-11 7.25 0 4.386 5.318 7.25 11 7.25zm0 1c-4.5 0-12-2.25-12-8.25 0-3.75 5.373-8.25 12-8.25s12 5.25 12 8.25c0 6-7.5 8.25-12 8.25z" />
      <path d="M16.5 17c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm0 1a6 6 0 1 1 0-12 6 6 0 0 1 0 12z" />
      <path d="M16.5 32C25.06 32 32 25.06 32 16.5 32 7.94 25.06 1 16.5 1 7.94 1 1 7.94 1 16.5 1 25.06 7.94 32 16.5 32zm0 1C7.387 33 0 25.613 0 16.5S7.387 0 16.5 0 33 7.387 33 16.5 25.613 33 16.5 33z" />
    </g>
  </SvgIcon>
);

export default AccountIcon;
